document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth >= 1024) {
    document.querySelectorAll('details.mega-menu').forEach(details => {
      const summary = details.querySelector('summary');

      // Prevent default toggle behavior
      if (summary) {
        summary.addEventListener('click', e => {
          e.preventDefault();
        });
      }

      // Add is-open class on hover
      details.addEventListener('mouseenter', () => {
        details.classList.add('is-open');
      });

      // Remove class on mouse leave
      details.addEventListener('mouseleave', () => {
        details.classList.remove('is-open');
      });
    });
  }
});
